export default [
    {path: '/tasks/:id', screen: 'task/DisplayTask', secured: true, role: ['admin']},
    {path: '/tasks', screen: 'task/ListTasks', secured: true, role: ['admin']},
]